import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  prManageForecastTreeData: [],
  prManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  prManageForecastFinalTreeData: [],
};

const PRManageScreenRedux = createSlice({
  name: "PRManageScreenRedux",
  initialState,
  reducers: {
    setPRManageForecastTreeData: (state, action) => {
      state.prManageForecastTreeData = action.payload;
    },
    setPRManageForecastBottlerData: (state, action) => {
      state.prManageForecastBottlerData = action.payload;
    },
    setPRManageForecastFinalTreeData: (state, action) => {
      state.prManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setPRManageForecastTreeData,
  setPRManageForecastBottlerData,
  setPRManageForecastFinalTreeData,
} = PRManageScreenRedux.actions;
export default PRManageScreenRedux.reducer;
